<mat-spinner [color]="color" [diameter]="diameter">
</mat-spinner>